import { render, staticRenderFns } from "./ApplicantMessageHistoryMessageDetail.vue?vue&type=template&id=1add44fc"
import script from "./ApplicantMessageHistoryMessageDetail.vue?vue&type=script&lang=js"
export * from "./ApplicantMessageHistoryMessageDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports